import { LayoutContent } from './layout-content';
import { LayoutRoot } from './layout-root';

/**
 * Entry point for Layout.Root and Layout.Content
 *
 * @since 10.0.0
 */
export const Layout = {
  Content: LayoutContent,
  Root: LayoutRoot,
};
